<script lang="ts">
  import Input from '$shared/atoms/Input/Input.svelte';
  import { Currency } from '$provider/constants/Currency';
  import { onMount } from 'svelte';

  interface Props {
    label?: string;
    icon?: string;
    name?: string;
    value?: number | string;
    error?: string;
    placeholder?: string;
    disabled?: boolean;
    tabIndex?: number;
    required?: boolean;
    onfocus?: (e: FocusEvent) => void;
    onchange?: (e: Event) => void;
    oninput?: (value: string) => void;
  }

  let {
    label = '',
    icon = '',
    name = '',
    value = '',
    error = $bindable(''),
    placeholder = '',
    disabled = false,
    tabIndex = 1,
    required = true,
    onfocus,
    onchange,
    oninput
  }: Props = $props();

  let inputValue = '';

  let currencyValue = $derived(
    typeof value === 'number'
      ? new Intl.NumberFormat(Currency.Locale, { currency: Currency.Type }).format(value)
      : ''
  );

  onMount(() => {
    inputValue = value?.toString() || '';
  });

  const normaliseValue = (value: string): string => {
    return value.replace(/,/g, '');
  };

  const inputChange = (detail: { value: string }): void => {
    inputValue = normaliseValue(detail.value?.trim());
    oninput?.(inputValue);
  };

  const onKeydown = (e: KeyboardEvent): void => {
    if (e.code !== 'Space') return;
    oninput?.(parseCurrencyValue(inputValue.toString()));
  };

  const onBlur = (): void => {
    oninput?.(parseCurrencyValue(inputValue.toString()));
  };

  const parseCurrencyValue = (inputValue: string): string => {
    if (validateInputKey(inputValue, 'K')) {
      return replaceInputKey(inputValue, 'K', '000');
    }
    if (validateInputKey(inputValue, 'M')) {
      return replaceInputKey(inputValue, 'M', '000000');
    }
    return inputValue;
  };

  const validateInputKey = (inputValue: string, validateKey: string): boolean => {
    return inputValue.toUpperCase().trim().endsWith(validateKey.toUpperCase());
  };

  const replaceInputKey = (inputValue: string, key: string, replaceValue: string): string => {
    return inputValue.toUpperCase().replace(key, replaceValue);
  };
</script>

<Input
  {label}
  {icon}
  {name}
  value={currencyValue}
  {error}
  {placeholder}
  {disabled}
  {tabIndex}
  {required}
  onblur={() => onBlur()}
  {onchange}
  {onfocus}
  oninput={inputChange}
  onkeydown={onKeydown}
/>
